import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
export function PromoBanner() {
  const [isVisible, setIsVisible] = useState(true);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 right-4 z-50 max-w-md bg-gradient-to-r from-purple-600 to-blue-600 text-white p-5 rounded-lg shadow-xl" data-id="element-244">
      <div className="absolute -top-2 -right-2" data-id="element-245">
        <button onClick={() => setIsVisible(false)} className="bg-white text-purple-600 rounded-full p-1 shadow-md hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-purple-500" aria-label="Close notification" data-id="element-246">
          <XIcon size={16} data-id="element-247" />
        </button>
      </div>
      <div className="flex items-start" data-id="element-248">
        <div className="mr-4 mt-1" data-id="element-249">
          <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center" data-id="element-250">
            <span className="text-xl" data-id="element-251">🎓</span>
          </div>
        </div>
        <div data-id="element-252">
          <h3 className="font-bold text-lg mb-2" data-id="element-253">Exclusive Benefit</h3>
          <p className="text-white/90 mb-3" data-id="element-254">
            As a Testbed School, you receive full, complimentary access to our
            premium Eedi Plus package, including 1-to-1 online tutor support for
            your students.
          </p>
          <button onClick={() => document.getElementById('application-form')?.scrollIntoView({
          behavior: 'smooth'
        })} className="text-sm font-medium bg-white text-purple-700 px-4 py-1.5 rounded-full hover:bg-gray-100 transition-colors shadow-sm" data-id="element-255">
            Apply Now
          </button>
        </div>
      </div>
    </div>;
}